import { useState } from "react";
import { isExperiment } from "../utils/googleOptimize";

let localSetData = () => null;

export const rerender = () => {
  localSetData(Math.random());
  if (!isExperiment()) {
    console.error('Rerender function should be used only inside the experiment.');
  }
}

const useRerender = () => {
  const [data, setData] = useState();

  localSetData = setData;

  return data;
}

export default useRerender;